import { ReactElement } from 'react';

import { WaitlistEntry } from '@dreryk/egabinet-waitlist-frontend-api';

import { Button, ButtonVariant } from '@dreryk/react-components';

import { WaitlistEntryConfirmReservationModalOpener } from '../../../confirmReservation/WaitlistEntryConfirmReservationModal.opener';
import { translationKeys } from '../../../translations';

type ConfirmReservationButtonProps = {
   readonly waitlistEntry: WaitlistEntry;
};

export const ConfirmReservationButton = (props: ConfirmReservationButtonProps): ReactElement => {
   return (
      <WaitlistEntryConfirmReservationModalOpener waitlistEntry={props.waitlistEntry}>
         {({ openModal }) => (
            <Button
               label={translationKeys.confirm}
               onClick={openModal}
               variant={ButtonVariant.SECONDARY}
               compact
               testId={'confirmReservation'}
            />
         )}
      </WaitlistEntryConfirmReservationModalOpener>
   );
};
